import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { parseISO } from "date-fns";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

function _toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'string') return parseISO(value);
  return null;
}

const _pad = (v) => String(v).padStart(2, '0');

export function formatDate(value) {
  if (!value) return '';
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [yyyy, mm, dd] = value.split('-');
    return `${dd}-${mm}-${yyyy}`;
  }
  try {
    const d = _toDate(value);
    if (!d) return '';
    const parts = {};
    for (const p of new Intl.DateTimeFormat('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit', month: '2-digit', year: 'numeric',
    }).formatToParts(d)) parts[p.type] = p.value;
    return `${_pad(parts.day)}-${_pad(parts.month)}-${parts.year}`;
  } catch {
    return '';
  }
}

export function formatDateTime(value) {
  if (!value) return '';
  try {
    const d = _toDate(value);
    if (!d) return '';
    const parts = {};
    for (const p of new Intl.DateTimeFormat('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit', hour12: false,
    }).formatToParts(d)) parts[p.type] = p.value;
    return `${_pad(parts.day)}-${_pad(parts.month)}-${parts.year} ${_pad(parts.hour)}:${_pad(parts.minute)}`;
  } catch {
    return '';
  }
}
